import React, { useEffect, useState } from "react";
import { Radio } from "@mui/material";
import { CircularProgress } from "@mui/material";
import ImportSiteIcon from "../assets/icons/ImportSiteIcon";
import DeleteIcon from "@mui/icons-material/Delete"; // Import this at the top
import Swal from "sweetalert2";

import {
  Grid,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Box,
  Checkbox,
  ListItemText,
} from "@mui/material";
import style from "../../components/RFPDashboard/CampaignDetails/Campaign.module.css";
import CustomInput from "../../shared/utils/Input";
import axios from "axios";
import "./vendorOnboard.css";
import FabricationMachine from "./FabricationMachine";
import PrintingMachineNeeded from "./PrintingMachineNeeded";
import { PlusIcon, UploadRfpIcon } from "../assets/icons";
import GlobalSnackbar from "../utils/GlobalSnackbar";
import ExcelLocationUploader from "./ExcelLocationUploader";

const columns = [
  {
    field: "srNo",
    headerName: "S. NO.",
    width: 20,
  },
  {
    field: "storeName",
    headerName: "STORE NAME",
    width: 80,
  },
  { field: "manager", headerName: "STORE MANAGER", width: 120 },
  { field: "address", headerName: "ADDRESS", width: 250 },
  { field: "pincode", headerName: "PIN CODE", width: 70 },
  { field: "city", headerName: "CITY", width: 80 },
  { field: "state", headerName: "STATE", width: 80 },
  { field: "productType", headerName: "PRODUCT TYPE", width: 80 },
  { field: "productWidth", headerName: "WIDTH (ft.)", width: 40 },

  { field: "productHeight", headerName: "HEIGHT (ft.)", width: 30 },

  { field: "productThickness", headerName: "THICKNESS (inch.)", width: 20 },
];

const printMachine = [
  { type: "Solvent Printing" },
  { type: "Ecosolvent Printing" },
  { type: "UV Printing" },
  { type: "Latex Printing" },
  { type: "Plotter Cutting Printing" },
  { type: "Digital Printing" },
];

const fabMachine = [
  { type: "Welding Machine" },
  { type: "Paint Compressor Machine" },
  { type: "CNC Router Machine" },
  { type: "Acrylic Laser Cutting Machine" },
  { type: "Channel Letter Bending Machine" },
];

const subCategories = {
  "Welding Machine": [
    { value: "Mig Welding Machine", label: "Mig Welding Machine" },
    { value: "Arc Welding Machine", label: "Arc Welding Machine" },
    { value: "Tig Welding Machine", label: "Tig Welding Machine" },
    { value: "Combi Welding Machine", label: "Combi Welding Machine" },
  ],
  "Acrylic Laser Cutting Machine": [
    {
      value: "Single Spindle",
      label: "Single Spindle",
    },
    {
      value: "Double Spindle",
      label: "Double Spindle",
    },
  ],
  "CNC Router Machine": [
    {
      value: "Single Spindle",
      label: "Single Spindle",
    },
    {
      value: "Double Spindle",
      label: "Double Spindle",
    },
  ],
  "Paint Compressor Machine": [
    {
      value: "Portable (2HP)",
      label: "Portable (2HP)",
    },
    {
      value: "Fixed (3HP & Above)",
      label: "Fixed (3HP & Above)",
    },
  ],
  "Channel Letter Bending Machine": [
    {
      value: "Stainless Steel(SS)",
      label: "Stainless Steel(SS)",
    },
    {
      value: "Aluminum",
      label: "Aluminum",
    },
    {
      value: "Hybrid",
      label: "Hybrid",
    },
  ],
};
const ProductComponent = ({
  setIsDeleted,
  setOtherSelectedIndexes,
  handleInputChange,
  otherSelectedIndexes,
  scopeOfWork,
  saveButtonClicked,
  selectedPrintMachines,
  setSelectedPrintMachines,
  setScopeOfWorks,
  validateForm,
  SOWUpdateDetails,
  excelLoading,
  deleteCheck,
  errors,
  index,
}) => {
  const fileInputForExcelRef = React.useRef(null);
  const [selectedMachines, setSelectedMachines] = useState([]);
  const handleMachineSelection = (machineType) => {
    setSelectedMachines((prevSelected) =>
      prevSelected.includes(machineType)
        ? prevSelected.filter((m) => m !== machineType)
        : [...prevSelected, machineType]
    );

    const updatedMachines = scopeOfWork.machinesNeededForFabrication.map(
      (machine) => ({
        ...machine,
        checked:
          machine.type === machineType ? !machine.checked : machine.checked,
      })
    );

    setScopeOfWorks((prevScopeOfWorks) =>
      prevScopeOfWorks.map((item) =>
        item.id === scopeOfWork.id
          ? { ...item, machinesNeededForFabrication: updatedMachines }
          : item
      )
    );
  };
  const handleDeleteMachineSelectionFab = (machineType) => {
    setSelectedMachines((prevSelected) =>
      prevSelected.filter((m) => m !== machineType)
    );

    const updatedMachines = scopeOfWork.machinesNeededForFabrication.map(
      (machine) =>
        machine.type === machineType
          ? {
              ...machine,
              checked: false,
              details: Object.fromEntries(
                Object.keys(machine.details).map((key) => [key, ""])
              ),
            }
          : machine
    );

    setScopeOfWorks((prevScopeOfWorks) =>
      prevScopeOfWorks.map((item) =>
        item.id === scopeOfWork.id
          ? { ...item, machinesNeededForFabrication: updatedMachines }
          : item
      )
    );
  };

  useEffect(() => {
    if (
      SOWUpdateDetails &&
      Array.isArray(SOWUpdateDetails.machinesNeededForFabrication) &&
      SOWUpdateDetails.machinesNeededForFabrication.length > 0
    ) {
      const initialMachines = SOWUpdateDetails.machinesNeededForFabrication.map(
        (machine) => machine.type
      );
      setSelectedMachines(initialMachines);
    } else {
      setSelectedMachines([]);
    }
  }, [SOWUpdateDetails?.machinesNeededForFabrication]);

  useEffect(() => {
    if (
      SOWUpdateDetails &&
      Array.isArray(SOWUpdateDetails.machinesNeededForPrinting) &&
      SOWUpdateDetails.machinesNeededForPrinting.length > 0
    ) {
      const initialMachines = SOWUpdateDetails.machinesNeededForPrinting.map(
        (machine) => machine.type
      );
      setSelectedPrintMachines(initialMachines);
    } else {
      setSelectedPrintMachines([]);
    }
  }, [SOWUpdateDetails?.machinesNeededForPrinting]);

  const handlePrintMachineSelection = (machineType) => {
    setSelectedPrintMachines((prevSelected) =>
      prevSelected.includes(machineType)
        ? prevSelected.filter((type) => type !== machineType)
        : [...prevSelected, machineType]
    );

    const updatedMachines = scopeOfWork.machinesNeededForPrinting.map(
      (machine) => ({
        ...machine,
        checked:
          machine.type === machineType ? !machine.checked : machine.checked,
      })
    );

    setScopeOfWorks((prevScopeOfWorks) =>
      prevScopeOfWorks.map((item) =>
        item.id === scopeOfWork.id
          ? { ...item, machinesNeededForPrinting: updatedMachines }
          : item
      )
    );
  };

  const handleDeleteMachineSelection = (machineType) => {
    setSelectedPrintMachines((prevSelected) =>
      prevSelected.filter((type) => type !== machineType)
    );
    const updatedMachines = scopeOfWork.machinesNeededForPrinting.map(
      (machine) =>
        machine.type === machineType ? { ...machine, checked: false } : machine
    );

    setScopeOfWorks((prevScopeOfWorks) =>
      prevScopeOfWorks.map((item) =>
        item.id === scopeOfWork.id
          ? { ...item, machinesNeededForPrinting: updatedMachines }
          : item
      )
    );
  };

  const [uploading, setUploadLoading] = useState(false);
  const [uploadingSecImage, setUploadLoadingSecImage] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [fileLoading, setFileLoading] = useState(false);
  const [specificationLoading, setSpecificationLoading] = useState(false);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const emptyInputCheck = (fieldName, value) => {
    if (value === "") {
      setRequiredFields({ ...requiredFields, [fieldName]: true });
    } else {
      setRequiredFields({ ...requiredFields, [fieldName]: false });
    }
  };
  const [requiredFields, setRequiredFields] = useState({});

  const handleIconClickForExcel = () => {
    if (fileInputForExcelRef.current) {
      fileInputForExcelRef.current.click();
    }
  };
  const handleDeleteExcel = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "All the locations, products, and related images will be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: true,
      backdrop: true,
      didOpen: () => {
        // Forcefully set z-index for SweetAlert container
        const swalContainer = document.querySelector(".swal2-container");
        if (swalContainer) {
          swalContainer.style.zIndex = "3000"; // Higher than MUI modals
          swalContainer.style.position = "fixed"; // Ensure it's not relative
        }
      },
    });

    if (result.isConfirmed) {
      if (SOWUpdateDetails?._id) {
        setIsDeleted(true);
      }

      setScopeOfWorks((prev) =>
        prev.map((ele) => {
          if (ele.id === scopeOfWork.id) {
            return {
              ...ele,
              locationsList: [],
              productDimensions: [],
            };
          }
          return ele;
        })
      );
    }
  };

  const handleImageUpload = async (e, index, checkImage) => {
    const file = e.target?.files?.[0];

    if (!file) {
      return;
    }

    if (checkImage == "firstImage") {
      setUploadLoading(true);
    } else {
      setUploadLoadingSecImage(true);
    }

    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        console.error("File is too large (max size: 2MB)");
        setUploadLoadingSecImage(false);
        setUploadLoading(false);
        setSnackbar({
          open: true,
          message: "File is too large (max size: 2MB)",
          severity: "error",
        });

        return;
      }

      const formDataNew = new FormData();
      formDataNew.append("files", file);

      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/upload`,
          formDataNew,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          if (checkImage == "firstImage") {
            setUploadLoading(false);
            setScopeOfWorks((prevScopeOfWorks) =>
              prevScopeOfWorks.map((item) => {
                return item.id === scopeOfWork.id
                  ? { ...item, printImage: response?.data?.data[0] }
                  : item;
              })
            );
            setSnackbar({
              open: true,
              message: "Product Image uploaded successfully",
              severity: "success",
            });
          }
          if (checkImage == "secondImage") {
            setUploadLoadingSecImage(false);
            setScopeOfWorks((prevScopeOfWorks) =>
              prevScopeOfWorks.map((item) => {
                return item.id === scopeOfWork.id
                  ? { ...item, productSecondImg: response?.data?.data[0] }
                  : item;
              })
            );
            setSnackbar({
              open: true,
              message: "Product 3D image uploaded successfully",
              severity: "success",
            });
          }
        }
      } catch (err) {
        setUploadLoadingSecImage(false);
        setUploadLoading(false);

        console.error("Error uploading file", err);
      }
    }
  };
  const handleButtonClick = (index) => {
    document.getElementById(`fileInput-${index}`).click();
  };
  const handleButtonSpecification = (index) => {
    document.getElementById(`specificationFile-${index}`).click();
  };
  const handleCADFileUpload = async (e, index) => {
    const file = e.target?.files?.[0];

    if (!file) {
      console.error("No file selected");
      return;
    }

    setFileLoading(true);

    if (file.size > 20 * 1024 * 1024) {
      console.error("File is too large (max size: 20MB)");
      setFileLoading(false);
      return;
    }

    const formDataNew = new FormData();
    formDataNew.append("files", file);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/upload`,
        formDataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setFileLoading(false);
        setScopeOfWorks((prevScopeOfWorks) =>
          prevScopeOfWorks.map((item) => {
            return item.id === scopeOfWork.id
              ? {
                  ...item,
                  materialDetailsForFabrication: {
                    ...item.materialDetailsForFabrication,
                    cadFile: response?.data?.data[0],
                  },
                }
              : item;
          })
        );
      }
    } catch (err) {
      console.error("Error uploading file", err);
      setFileLoading(false);
    }
  };
  const handleSpecificationUpload = async (e, index) => {
    const file = e.target?.files?.[0];

    if (!file) {
      console.error("No file selected");
      return;
    }

    setSpecificationLoading(true);

    if (file.size > 2 * 1024 * 1024) {
      console.error("File is too large (max size: 2MB)");
      setSpecificationLoading(false);
      return;
    }

    const formDataNew = new FormData();
    formDataNew.append("files", file);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/upload`,
        formDataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setSpecificationLoading(false);
        setScopeOfWorks((prevScopeOfWorks) =>
          prevScopeOfWorks.map((item) => {
            return item.id === scopeOfWork.id
              ? {
                  ...item,
                  materialDetailsForFabrication: {
                    ...item.materialDetailsForFabrication,
                    specificationFile: response?.data?.data[0],
                  },
                }
              : item;
          })
        );
      }
    } catch (err) {
      console.error("Error uploading file", err);
      setSpecificationLoading(false);
    }
  };
  return (
    <div className="w-full rounded-b-lg ">
      <Grid
        className=" rounded-b-lg "
        item
        md={8}
        lg={8}
        sx={{
          overflow: "auto",
          boxSizing: "border-box",
          padding: "0px 10px",
          border: "none",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
        }}
      >
        <Box
          className={style.boxStyling}
          sx={{
            overflow: "auto",
          }}
        >
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label style={{ fontWeight: "400", color: "#36383A" }}>
                Product Category
              </label>
              <FormControl
                fullWidth
                size="small"
                sx={{ marginTop: "0.5rem", marginBottom: "7px" }}
              >
                <Select
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                  name={`productCategoryForRecceInstallAudit-${index}`}
                  value={scopeOfWork?.productCategoryForRecceInstallAudit}
                  onChange={(e) => {
                    handleInputChange(e, index);
                  }}
                  renderValue={(selected) => {
                    if (!selected || selected.length === 0) {
                      return (
                        <p className="text-[1rem] text-[var(--listdown-color)]">
                          Select Category
                        </p>
                      );
                    }
                    return <span style={{ color: "#000" }}>{selected}</span>;
                  }}
                >
                  {combinedCategories.map((category, i) => (
                    <MenuItem key={i} value={category}>
                      <Radio
                        checked={
                          scopeOfWork?.productCategoryForRecceInstallAudit ===
                          category
                        }
                        onChange={(e) =>
                          handleInputChange(
                            {
                              target: {
                                name: `combinedCategories-${index}`,
                                value: category,
                              },
                            },
                            index
                          )
                        }
                        style={{ paddingRight: "8px" }}
                      />
                      {category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="flex flex-col">
              <label
                style={{
                  fontWeight: "400",
                  color: "#36383A",
                  marginBottom: "8px",
                }}
              >
                Services
              </label>

              <FormControl className="w-full" size="small">
                <Select
                  name={`servicesNeeded-${index}`}
                  value={scopeOfWork?.servicesNeeded || []}
                  displayEmpty
                  multiple={true}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return (
                        <p className="text-sm text-gray-500">
                          {" "}
                          Select Services
                        </p>
                      );
                    }
                    return selected.join(", ");
                  }}
                  onChange={(e) => handleInputChange(e, index)}
                >
                  {servicesList.map((service, i) => (
                    <MenuItem value={service} key={i}>
                      <Checkbox
                        checked={scopeOfWork?.servicesNeeded.includes(service)}
                      />
                      <ListItemText primary={service} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="flex flex-col">
              <CustomInput
                name={`price-${index}`}
                placeholder="Enter Price In Rupees"
                title="Price (per sq. ft.)*"
                value={scopeOfWork.price}
                size="small"
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value) && !value.startsWith(" ")) {
                    handleInputChange(e, index);
                  }
                }}
                onBlur={(e) => {
                  emptyInputCheck(e.target.name, e.target.value);
                  if (saveButtonClicked) validateForm(scopeOfWork);
                }}
                error={errors[`price-${index}`]}
                required
              />
              {errors[`price-${index}`] && (
                <span className="ml-2" style={{ color: "var(--error-color)" }}>
                  Price is required
                </span>
              )}
            </div>

            <CustomInput
              name="totalArea"
              placeholder="Enter Area"
              title="Total Area (sq. ft.)"
              type="number"
              size="small"
              disabled
              value={SOWUpdateDetails?.totalArea || scopeOfWork.totalArea || ""}
              onChange={(e) => {
                if (
                  !e.target.value.startsWith(" ") &&
                  e.target.value.length < 7
                ) {
                  handleInputChange(e);
                }
              }}
              onBlur={(e) => {
                emptyInputCheck(e.target.name, e.target.value);
                if (saveButtonClicked) validateForm(scopeOfWork);
              }}
              error={errors.totalArea}
            />
            <CustomInput
              name={`budget-${index}`}
              placeholder="Total Price"
              title="Total Campaign Value"
              disabled
              type="number"
              size="small"
              value={scopeOfWork?.budget || ""}
              onChange={(e) => {
                handleInputChange(e);
              }}
            />
            <CustomInput
              name={`experienceOfFabrication-${index}`}
              placeholder="Enter Experience Of Fabrication (in Yrs)"
              title="Experience Of Fabrication (in Yrs)"
              size="small"
              required
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value) && !value.startsWith(" ")) {
                  handleInputChange(e, index);
                }
              }}
              value={scopeOfWork?.experienceOfFabrication}
            />
            <CustomInput
              name={`areaNeededForFabrication-${index}`}
              sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
              placeholder="Enter Area Needed For Fabrication (in sq. Ft)"
              title="Area Needed For Fabrication (in sq. Ft)"
              size="small"
              required
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value) && !value.startsWith(" ")) {
                  handleInputChange(e, index);
                }
              }}
              value={scopeOfWork?.areaNeededForFabrication}
            />
          </div>
          <div className="border rounded-lg px-5 py-2 my-4 shadow-lg">
            <label>Product Rendition Images</label>
            <div className="border w-full my-2 rounded-lg" />

            <div className="w-full flex justify-start items-center gap-2 ">
              <div className="w-[50%] border rounded-lg p-2">
                <label>Corel Draw File</label>
                <div className="w-full   flex justify-between items-center ">
                  <div>
                    {" "}
                    {fileLoading ? (
                      <p>Uploading... </p>
                    ) : scopeOfWork.materialDetailsForFabrication.cadFile ? (
                      <div>
                        <div className="text-green-500 border border-gray-400 py-2 mt-1.5 px-2 rounded-md">
                          {" "}
                          File Uploaded Successfully
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <button
                    className="btn flex items-center gap-2 rounded-lg shadow-lg text-white px-4 py-2 bg-[var(--primary-color)]"
                    onClick={() => handleButtonClick(index)}
                  >
                    <PlusIcon color="white" size="14px" /> Add Corel File
                  </button>

                  <input
                    className="hidden"
                    id={`fileInput-${index}`}
                    type="file"
                    accept=".dwg,.dxf,.cdr"
                    name={`materialDetailsForFabrication-cadFile-${index}`}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        if (
                          file.name.endsWith(".dxf") ||
                          file.name.endsWith(".dwg") ||
                          file.name.endsWith(".cdr")
                        ) {
                          handleCADFileUpload(e, index);
                        } else {
                          console.error(
                            "Invalid file type. Only .dwg and .dxf files are allowed."
                          );
                        }
                      }
                    }}
                  />
                </div>
              </div>
              <div className="w-[50%] border rounded-lg p-2">
                <label>Specification File</label>
                <div className="w-full   flex justify-between items-center rounded-lg">
                  <div>
                    {" "}
                    {specificationLoading ? (
                      <p>Uploading... </p>
                    ) : scopeOfWork.materialDetailsForFabrication
                        .specificationFile ? (
                      <div className="flex items-center justify-between">
                        <a
                          href={
                            scopeOfWork.materialDetailsForFabrication
                              .specificationFile
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="text-green-500 border border-gray-400 py-2 mt-1.5 px-2 rounded-md cursor-pointer">
                            Click to View
                          </div>
                        </a>

                        {/* Delete Icon */}
                        <DeleteIcon
                          className="text-red-500 cursor-pointer ml-2"
                          onClick={() => {
                            // Update the state to clear the file
                            setScopeOfWorks((prevScopeOfWorks) =>
                              prevScopeOfWorks.map((item) => {
                                return item.id === scopeOfWork.id
                                  ? {
                                      ...item,
                                      materialDetailsForFabrication: {
                                        ...item.materialDetailsForFabrication,
                                        specificationFile: "",
                                      },
                                    }
                                  : item;
                              })
                            );
                          }}
                        />
                      </div>
                    ) : null}
                  </div>
                  <button
                    className="btn flex items-center gap-2 rounded-lg shadow-lg text-white px-4 py-2 bg-[var(--primary-color)]"
                    onClick={() => handleButtonSpecification(index)}
                  >
                    <PlusIcon color="white" size="14px" />
                    {scopeOfWork.materialDetailsForFabrication.specificationFile
                      ? "Change"
                      : "Add"}{" "}
                    Specification File
                  </button>

                  <input
                    className="hidden"
                    id={`specificationFile-${index}`}
                    type="file"
                    accept=".pdf"
                    name={`materialDetailsForFabrication-specificationFile-${index}`}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        if (file.name.endsWith(".pdf")) {
                          handleSpecificationUpload(e, index);
                        } else {
                          console.error(
                            "Invalid file type. Only .pdf files are allowed."
                          );
                        }
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="p-1 flex items-center justify-center gap-10 w-full ">
              <Grid lg={12} className=" w-[50%]">
                <label className="my-3">Product Image</label>
                <div
                  style={{
                    border: "2px dashed var(--primary-color)",
                    padding: "10px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    minHeight: "350px",
                    marginTop: 8,
                  }}
                  className="bg-[var(--bg-color)] relative rounded-2xl max-w-[650px] w-auto"
                >
                  {uploading ? (
                    <CircularProgress size={30} />
                  ) : scopeOfWork?.printImage ? (
                    <>
                      <img
                        onClick={() =>
                          document
                            .getElementById(`fileInputImage-${index}`)
                            .click()
                        }
                        src={scopeOfWork?.printImage}
                        alt="Uploaded or default"
                        className="w-full  rounded-lg cursor-pointer object-contain"
                        style={{ borderRadius: "inherit", maxHeight: "310px" }}
                      />
                      <input
                        id={`fileInputImage-${index}`}
                        type="file"
                        accept="image/*"
                        name={`printImage-${index}`}
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            handleImageUpload(e, index, "firstImage");
                          }
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <div
                        className="cursor-pointer"
                        onClick={() =>
                          document
                            .getElementById(`fileInputImage-${index}`)
                            .click()
                        }
                      >
                        <UploadRfpIcon
                          color={"var(--primary-color)"}
                          size="70"
                        />
                      </div>
                      <input
                        id={`fileInputImage-${index}`}
                        type="file"
                        accept="image/*"
                        name={`printImage-${index}`}
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            handleImageUpload(e, index, "firstImage");
                          }
                        }}
                      />
                      <span
                        style={{
                          marginTop: "10px",
                          color: "var(--primary-color)",
                          textAlign: "center",
                        }}
                      >
                        Upload image in .jpeg, .png format <br />{" "}
                        <span>Max size allowed 2MB</span>
                      </span>
                    </>
                  )}
                </div>
              </Grid>
              <Grid lg={12} className=" w-[50%]">
                <label className="mb-3 mt-4">Product 3D Image</label>
                <div
                  style={{
                    border: "2px dashed var(--primary-color)",
                    padding: "10px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    minHeight: "350px",
                    marginTop: 8,
                  }}
                  className="bg-[var(--bg-color)] relative rounded-2xl max-w-[650px] w-auto"
                >
                  {uploadingSecImage ? (
                    <CircularProgress size={30} />
                  ) : scopeOfWork?.productSecondImg ? (
                    <>
                      <img
                        onClick={() =>
                          document
                            .getElementById(`fileInputImage2-${index}`)
                            .click()
                        }
                        src={scopeOfWork?.productSecondImg}
                        alt="Uploaded or default"
                        className="w-full rounded-lg cursor-pointer object-contain"
                        style={{ borderRadius: "inherit", maxHeight: "310px" }}
                      />
                      <input
                        id={`fileInputImage2-${index}`}
                        type="file"
                        accept="image/*"
                        name={`productSecondImg-${index}`}
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            handleImageUpload(e, index, "secondImage");
                          }
                        }}
                      />
                    </>
                  ) : (
                    <div className="flex flex-col items-center justify-center">
                      <div
                        className="cursor-pointer "
                        onClick={() =>
                          document
                            .getElementById(`fileInputImage2-${index}`)
                            .click()
                        }
                      >
                        <UploadRfpIcon
                          color={"var(--primary-color)"}
                          size="70"
                        />
                      </div>
                      <input
                        id={`fileInputImage2-${index}`}
                        type="file"
                        accept="image/*"
                        name={`productSecondImg-${index}`}
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            handleImageUpload(e, index, "secondImage");
                          }
                        }}
                      />
                      <span
                        style={{
                          marginTop: "10px",
                          color: "var(--primary-color)",
                          textAlign: "center",
                        }}
                      >
                        Upload image in .jpeg, .png format <br />{" "}
                        <span>Max size allowed 2MB</span>
                      </span>
                    </div>
                  )}
                </div>
              </Grid>
              {errors.printImage && (
                <span
                  className="mt-2"
                  style={{ color: "var(--error-color) !important" }}
                >
                  Please upload an image
                </span>
              )}
            </div>
          </div>
          <GlobalSnackbar
            snackbar={snackbar}
            handleClose={handleSnackbarClose}
          />

          {/* {scopeOfWork?.locationsList?.length === 0 ? (
            <div className="border  rounded-lg mb-8 shadow-lg">
              <div className="flex justify-between items-center w-full bg-[#e0edf4] p-2 rounded-t-lg">
                <div className="flex justify-center items-center">
                  <h1
                    style={{
                      color: errors[`locationsList-${index}`]
                        ? "var(--error-color)"
                        : "inherit",
                    }}
                  >
                    Sites
                  </h1>
                  <span
                    style={{
                      color: "var(--error-color)",
                    }}
                  >
                    *
                  </span>
                </div>
                <div>
                  <div className="flex justify-center items-center  mb-2">
                    {excelLoading ? (
                      <CircularProgress size={30} />
                    ) : (
                      <div>
                        <input
                          type="file"
                          ref={fileInputForExcelRef}
                          name={`locationsList-${index}`}
                          onChange={async (e) => {
                            handleInputChange(e, index);
                          }}
                          style={{
                            display: "none",
                          }}
                          accept=".xlsx"
                        />
                        <button
                          onClick={handleIconClickForExcel}
                          className="px-2 py-2 w-36 gap-2 items-center justify-center mr-2 flex cursor-pointer text-[var(--secondary-color)] bg-[var(--primary-color)] border-[var(--primary-color)] border rounded-lg"
                        >
                          <ImportSiteIcon />
                          Import Sites
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center">
                <h3 className="w-full text-center mt-2 p-5 ">
                  There is no location added yet
                </h3>
              </div>
            </div>
          ) : (
            <>
              <Grid
                className="bg-[var(--secondary-color)] shadow-md  p-4 border rounded-lg my-5"
                spacing={3}
              >
                <div className="flex justify-between items-center">
                  <div className="flex flex-col  mb-5  lg:flex-row justify-between items-center gap-7">
                    <h1 className="font-[600]">{`Locations : ${scopeOfWork?.locationsList?.length}`}</h1>
                  </div>
                  <button
                    onClick={handleDeleteExcel}
                    className="px-2 py-2 w-36 gap-2 items-center mb-5 justify-center mr-2 flex cursor-pointer text-[var(--secondary-color)] bg-[var(--error-color)] border-[var(--secondary-color)] border rounded-lg"
                  >
                    <ImportSiteIcon />
                    Delete Sites
                  </button>
                </div>

                <TableContainer
                  className={`mt-5 rounded-lg ${style["custom-scrollbar"]}`}
                  sx={{
                    overflowY: "auto",
                    maxWidth: "full",
                    margin: "auto",
                    maxHeight: 300,
                  }}
                >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {columns?.map((column) => (
                          <TableCell
                            key={column.field}
                            sx={{
                              whiteSpace: "nowrap",
                              fontWeight: "550",
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#e0e0e0",
                              width: column.width,
                              zIndex: 2,
                            }}
                          >
                            <span
                              style={{ lineHeight: "1", width: column.width }}
                            >
                              {column.headerName
                                .toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")}
                            </span>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {scopeOfWork?.locationsList?.map((location, i) => {
                        return (
                          <TableRow key={i}>
                            <TableCell>{i + 1 + "."}</TableCell>
                            <TableCell>
                              {location?.storeName
                                ? location.storeName.charAt(0).toUpperCase() +
                                  location.storeName.slice(1)
                                : "N/A"}
                            </TableCell>
                            <TableCell align="left">
                              <div className="flex justify-center items-center">
                                <div className="border text-[var(--primary-color)] px-2 py-1 rounded">
                                  {location?.storeOwnerName
                                    ?.split(" ")
                                    .map((ele) => ele.charAt(0).toUpperCase())
                                    .join("")}
                                </div>

                                <div className="ml-2">
                                  <span className="block font-medium">
                                    {location?.storeOwnerName
                                      ? location.storeOwnerName
                                          .charAt(0)
                                          .toUpperCase() +
                                        location.storeOwnerName.slice(1)
                                      : "N/A"}
                                  </span>
                                  <span className="text-gray-400 text-xs">
                                    {location?.storeOwnerPhoneNumber ?? "NA"}
                                  </span>
                                </div>
                              </div>
                            </TableCell>

                            <TableCell align="left">
                              {typeof location.address === "string"
                                ? location.address
                                : location.address?.richText
                                    ?.map((item) => item.text)
                                    .join(" ")}
                            </TableCell>
                            <TableCell align="left">
                              {location?.zipCode}
                            </TableCell>

                            <TableCell align="left">{location?.city}</TableCell>
                            <TableCell align="left">
                              {location?.state}
                            </TableCell>
                            <TableCell align="center">
                              {scopeOfWork?.productDimensions[i]
                                ?.productWidth || "N/A"}
                            </TableCell>
                            <TableCell align="center">
                              {scopeOfWork?.productDimensions[i]
                                ?.productHeight || "N/A"}
                            </TableCell>

                            <TableCell align="center">
                              {scopeOfWork?.productDimensions[i]
                                ?.productThickness || "N/A"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </>
          )} */}

          <div className="border  rounded-lg mb-8 shadow-lg">
            <div className="flex justify-between items-center w-full bg-[#e0edf4] px-2 py-4 rounded-t-lg">
              <h1>Description For Vendor</h1>
              <p className="text-sm text-gray-500">
                Word count:{" "}
                {
                  (scopeOfWork?.description ?? "")
                    .trim()
                    .split(/\s+/)
                    .filter((word) => word).length
                }{" "}
                / 200
              </p>
            </div>
            <div className="flex justify-center items-center">
              <TextField
                className="text-xs font-medium leading-6 text-left w-full"
                placeholder="Enter Your Description"
                title="Description"
                multiline
                type="text"
                name={`description-${index}`}
                value={scopeOfWork?.description ?? ""}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const words = inputValue
                    .trim()
                    .split(/\s+/)
                    .filter((word) => word);

                  if (words.length <= 200) {
                    handleInputChange(e, index);
                  }
                }}
                rows={5}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "var(--primary-color)",
                    },
                  },
                }}
              />
            </div>
          </div>

          <div className="border  rounded-lg mb-8 shadow-lg">
            <div className="flex justify-between items-center w-full bg-[#e0edf4] p-2 rounded-t-lg">
              <div className="flex justify-center items-center py-2">
                <h1>Packaging Guidelines</h1>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <TextField
                className="text-xs font-medium leading-6 text-left w-full"
                placeholder="Enter Packaging Guidelines"
                title="Packaging Guidelines"
                multiline
                type="text"
                rows={5}
                size="small"
                name={`packagingGuidelines-${index}`}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    const currentValue = scopeOfWork?.packagingGuidelines || "";

                    const newValue = currentValue + "\n• ";

                    const syntheticEvent = {
                      target: {
                        name: `packagingGuidelines-${index}`,
                        value: newValue,
                      },
                    };

                    handleInputChange(syntheticEvent, index);
                  }
                }}
                value={
                  scopeOfWork?.packagingGuidelines?.startsWith("•")
                    ? scopeOfWork.packagingGuidelines
                    : "• " + (scopeOfWork?.packagingGuidelines ?? "")
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {},
                    "&:hover fieldset": {},
                    "&.Mui-focused fieldset": {
                      borderColor: "var(--primary-color)",
                    },
                  },
                }}
                onChange={(e) => handleInputChange(e, index)}
              />
            </div>
          </div>
          <div className="border  rounded-lg mb-8 shadow-lg">
            <div className="flex justify-between items-center w-full bg-[#e0edf4] p-2 rounded-t-lg">
              <div className="flex justify-center items-center py-2">
                <h1>Delivery Guidelines</h1>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <TextField
                className="text-xs font-medium leading-6 text-left w-full"
                placeholder="Enter Your Description"
                title="Delivery Guidelines"
                multiline
                type="text"
                rows={5}
                size="small"
                name={`deliveryGuidelines-${index}`}
                value={
                  scopeOfWork?.deliveryGuidelines?.startsWith("•")
                    ? scopeOfWork.deliveryGuidelines
                    : scopeOfWork?.deliveryGuidelines ?? ""
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    const currentValue = scopeOfWork?.deliveryGuidelines || "";

                    const newValue = currentValue + "\n• ";

                    const Event = {
                      target: {
                        name: `deliveryGuidelines-${index}`,
                        value: newValue,
                      },
                    };

                    handleInputChange(Event, index);
                  }
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {},
                    "&:hover fieldset": {},
                    "&.Mui-focused fieldset": {
                      borderColor: "var(--primary-color)",
                    },
                  },
                }}
                onChange={(e) => handleInputChange(e, index)}
              />
            </div>
          </div>

          <div className="border  rounded-lg mb-8 shadow-lg">
            <div className="flex justify-between items-center w-full bg-[#e0edf4] p-2 rounded-t-lg">
              <div className="flex justify-center items-center py-2">
                <h1>PDI Guidelines</h1>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <TextField
                className="text-xs font-medium leading-6 text-left w-full"
                placeholder="Enter PDI Guidelines"
                title="PDI Guidelines"
                multiline
                type="text"
                rows={5}
                size="small"
                name={`pdiGuidelines-${index}`}
                value={
                  scopeOfWork?.pdiGuidelines?.startsWith("•")
                    ? scopeOfWork.pdiGuidelines
                    : "• " + (scopeOfWork?.pdiGuidelines ?? "")
                }
                onChange={(e) => handleInputChange(e, index)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    const currentValue = scopeOfWork?.pdiGuidelines || "";

                    const newValue = currentValue + "\n• ";

                    const syntheticEvent = {
                      target: {
                        name: `pdiGuidelines-${index}`,
                        value: newValue,
                      },
                    };

                    handleInputChange(syntheticEvent, index);
                  }
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "var(--primary-color)",
                    },
                  },
                }}
              />
            </div>
          </div>

          {scopeOfWork?.servicesNeeded?.includes("Fabrication") && (
            <FabricationMachine
              scopeOfWork={scopeOfWork}
              handleDeleteMachineSelectionFab={handleDeleteMachineSelectionFab}
              fabMachine={fabMachine}
              index={index}
              handleInputChange={handleInputChange}
              categoryLabels={categoryLabels}
              selectedMachines={selectedMachines}
              subCategories={subCategories}
              handleMachineSelection={handleMachineSelection}
              errors={errors}
            />
          )}

          {scopeOfWork?.servicesNeeded?.includes("Fabrication") && (
            <div className="border  rounded-lg pb-2 mb-3">
              <div className="flex justify-between items-center w-full bg-[#e0edf4] p-4 rounded-t-lg">
                <h1 className="font-[600]">
                  Fabrication Material Specification
                </h1>
              </div>
              <div className="border rounded-lg px-5 py-4 m-3 ">
                <h1 className="font-[600]"> Mechanical</h1>
                <div className="border w-full my-2 rounded-lg" />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 p-4 mt-3 mb-4">
                  <CustomInput
                    name={`materialDetailsForFabrication-frameDetailsections-${index}`}
                    placeholder="Enter Sections"
                    title=" Frame Sections"
                    size="small"
                    type="text"
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.frameDetailsections
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-frameDetailwallThickness-${index}`}
                    placeholder="Enter Wall Thickness"
                    title=" Frame Wall Thickness"
                    size="small"
                    type="text"
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.frameDetailwallThickness
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-frameDetailweight-${index}`}
                    placeholder="Enter Weight"
                    title=" Frame Weight"
                    size="small"
                    type="text"
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.frameDetailweight
                    }
                  />
                  {/* <CustomInput
                    name={`materialDetailsForFabrication-size-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Size"
                    title="Size (inches)"
                    size="small"
                    required
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e, index);
                      }
                    }}
                    value={scopeOfWork?.materialDetailsForFabrication?.size}
                  /> */}
                  <CustomInput
                    name={`materialDetailsForFabrication-backingmaterial-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Material"
                    title="Backing Material"
                    size="small"
                    required
                    onChange={(e) =>
                      handleInputChange(e, index, "backingmaterial")
                    }
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.backingmaterial || ""
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-backingthickness-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Thickness"
                    title="Backing Thickness"
                    size="small"
                    required
                    onChange={(e) =>
                      handleInputChange(e, index, "backingthickness")
                    }
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.backingthickness || ""
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-backinggrade-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Grade"
                    title="Backing Grade"
                    size="small"
                    required
                    onChange={(e) =>
                      handleInputChange(e, index, "backinggrade")
                    }
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.backinggrade || ""
                    }
                  />

                  <CustomInput
                    name={`materialDetailsForFabrication-raisingheight-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Height"
                    title="Raising Height"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication?.raisingheight
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-raisingmaterial-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Material"
                    title="Raising Material"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.raisingmaterial
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-raisingthickness-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Thickness"
                    title="Raising Thickness"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.raisingthickness
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-raisinggrade-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Grade"
                    title="Raising Grade"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication?.raisinggrade
                    }
                  />

                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ marginBottom: "7px" }}
                  >
                    <label
                      style={{
                        fontWeight: "400",
                        color: "#36383A",
                        marginBottom: "8px",
                      }}
                    >
                      Application Place
                    </label>
                    <Select
                      name={`materialDetailsForFabrication-applicationPlace-${index}`}
                      value={
                        scopeOfWork?.materialDetailsForFabrication
                          ?.applicationPlace || ""
                      }
                      onChange={(e) => {
                        handleInputChange(e, index);
                      }}
                      displayEmpty
                      inputProps={{ "aria-label": "Select Application Place" }}
                      sx={{ marginTop: "0.5rem" }}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span className="text-[var(--listdown-color)]">
                              Select Application Place
                            </span>
                          );
                        }
                        return selected;
                      }}
                    >
                      <MenuItem value="Indoor">
                        <Radio
                          checked={
                            scopeOfWork?.materialDetailsForFabrication
                              ?.applicationPlace === "Indoor"
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              handleInputChange(
                                {
                                  target: {
                                    name: `materialDetailsForFabrication-applicationPlace-${index}`,
                                    value: "Indoor",
                                  },
                                },
                                index
                              );
                            }
                          }}
                          style={{ paddingRight: "8px" }}
                        />
                        Indoor
                      </MenuItem>

                      <MenuItem value="Outdoor">
                        <Radio
                          checked={
                            scopeOfWork?.materialDetailsForFabrication
                              ?.applicationPlace === "Outdoor"
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              handleInputChange(
                                {
                                  target: {
                                    name: `materialDetailsForFabrication-applicationPlace-${index}`,
                                    value: "Outdoor",
                                  },
                                },
                                index
                              );
                            }
                          }}
                          style={{ paddingRight: "8px" }}
                        />
                        Outdoor
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ marginBottom: "7 px" }}
                  >
                    <label
                      style={{
                        fontWeight: "400",
                        color: "#36383A",
                        marginBottom: "8px",
                      }}
                    >
                      Face
                    </label>
                    <Select
                      name={`materialDetailsForFabrication-face-${index}`}
                      value={
                        scopeOfWork?.materialDetailsForFabrication?.face || ""
                      }
                      onChange={(e) => {
                        handleInputChange(e, index);
                      }}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span className="text-[var(--listdown-color)]">
                              Select Face
                            </span>
                          );
                        }
                        return selected;
                      }}
                      inputProps={{ "aria-label": "Select Face" }}
                      sx={{ marginTop: "0.5rem" }}
                    >
                      <MenuItem value="Single Sided">
                        <Radio
                          checked={
                            scopeOfWork?.materialDetailsForFabrication?.face ===
                            "Single Sided"
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              handleInputChange(
                                {
                                  target: {
                                    name: `materialDetailsForFabrication-face-${index}`,
                                    value: "Single Sided",
                                  },
                                },
                                index
                              );
                            }
                          }}
                          style={{ paddingRight: "8px" }}
                        />
                        Single Sided
                      </MenuItem>

                      <MenuItem value="Double Sided">
                        <Radio
                          checked={
                            scopeOfWork?.materialDetailsForFabrication?.face ===
                            "Double Sided"
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              handleInputChange(
                                {
                                  target: {
                                    name: `materialDetailsForFabrication-face-${index}`,
                                    value: "Double Sided",
                                  },
                                },
                                index
                              );
                            }
                          }}
                          style={{ paddingRight: "8px" }}
                        />
                        Double Sided
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="border rounded-lg px-5 py-4 m-3 ">
                <h1 className="font-[600]"> Electrical</h1>
                <div className="border w-full  my-2 rounded-lg" />

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 p-6 my-2 ">
                  <CustomInput
                    name={`materialDetailsForFabrication-lightSourcetype-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7px" }}
                    placeholder="Enter Type"
                    title="Light Source Type"
                    size="small"
                    type="text"
                    onChange={(e) => {
                      const value = e.target.value;
                      handleInputChange(e, index);
                    }}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.lightSourcetype
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-lightSourcebrand-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Brand"
                    title=" Light Source Brand"
                    size="small"
                    type="text"
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.lightSourcebrand
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-lightSourcemodelNo-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Model No."
                    title=" Light Source Model No."
                    size="small"
                    type="text"
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.lightSourcemodelNo
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-lightSourceqty-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Quantity"
                    title=" Light Source Quantity"
                    size="small"
                    value={
                      scopeOfWork?.materialDetailsForFabrication?.lightSourceqty
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value) && !value.startsWith(" ")) {
                        handleInputChange(e, index);
                      }
                    }}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm(scopeOfWork);
                    }}
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-lightSourcecolorTemp-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Color Temp."
                    title=" Light Source Color Temp."
                    size="small"
                    type="text"
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.lightSourcecolorTemp
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-lightSourcewattage-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Wattage"
                    title=" Light Source Wattage"
                    size="small"
                    type="text"
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication
                        ?.lightSourcewattage
                    }
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-wiringsize-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Size"
                    title="Wiring Size"
                    type="text"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication?.wiringsize
                    }
                    error={errors.materialDetailsForFabrication?.wiring?.size}
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-wiringtype-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Type"
                    title="Wiring Type"
                    type="text"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication?.wiringtype
                    }
                    error={errors.materialDetailsForFabrication?.wiring?.type}
                  />
                  <CustomInput
                    name={`materialDetailsForFabrication-wiringbrand-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Brand"
                    title="Wiring Brand"
                    type="text"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    value={
                      scopeOfWork?.materialDetailsForFabrication?.wiringbrand
                    }
                    error={errors.materialDetailsForFabrication?.wiring?.brand}
                  />
                </div>
              </div>

              <div className="border rounded-lg px-5 py-4 m-3 ">
                <h1 className="font-[600]"> Paint</h1>
                <div className="border w-full  my-2 rounded-lg" />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-2 px-6 py-2 my-2 ">
                  <CustomInput
                    name={`materialDetailsForFabrication-paint-${index}`}
                    sx={{ marginTop: "0.5rem", marginBottom: "7 px" }}
                    placeholder="Enter Paint"
                    title="Paint"
                    size="small"
                    required
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e, index);
                      }
                    }}
                    value={scopeOfWork?.materialDetailsForFabrication?.paint}
                  />
                </div>
              </div>
            </div>
          )}
          {scopeOfWork?.servicesNeeded?.includes("Fabrication") && (
            <div className="border  rounded-lg mb-8 shadow-lg">
              <div className="flex justify-between items-center w-full bg-[#e0edf4] p-2 rounded-t-lg">
                <div className="flex justify-center items-center py-2">
                  <h1>Fabrication Guidelines</h1>
                </div>
              </div>
              <div className="flex justify-center items-center">
                <TextField
                  className="text-xs font-medium leading-6 text-left w-full"
                  title="Fabrication Guidelines"
                  multiline
                  type="text"
                  rows={5}
                  size="small"
                  name={`fabricationGuidelines-${index}`}
                  value={
                    scopeOfWork?.fabricationGuidelines?.startsWith("•")
                      ? scopeOfWork.fabricationGuidelines
                      : "• " + (scopeOfWork?.fabricationGuidelines ?? "")
                  }
                  onChange={(e) => handleInputChange(e, index)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const currentValue =
                        scopeOfWork?.fabricationGuidelines || "";

                      const newValue = currentValue + "\n• ";

                      const syntheticEvent = {
                        target: {
                          name: `fabricationGuidelines-${index}`,
                          value: newValue,
                        },
                      };

                      handleInputChange(syntheticEvent, index);
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "var(--primary-color)",
                      },
                    },
                  }}
                />
              </div>
            </div>
          )}
          {scopeOfWork?.servicesNeeded?.includes("Printing") && (
            <PrintingMachineNeeded
              handleDeleteMachineSelection={handleDeleteMachineSelection}
              errors={errors}
              handlePrintMachineSelection={handlePrintMachineSelection}
              printMachine={printMachine}
              selectedPrintMachines={selectedPrintMachines}
              scopeOfWork={scopeOfWork}
              otherSelectedIndexes={otherSelectedIndexes}
              setOtherSelectedIndexes={setOtherSelectedIndexes}
              handleInputChange={handleInputChange}
              brandNames={brandNames}
              width={width}
              index={index}
            />
          )}
          {scopeOfWork?.servicesNeeded?.includes("Printing") && (
            <div className="border  rounded-lg pb-2">
              <div className="flex justify-between items-center w-full bg-[#e0edf4] px-3 rounded-t-lg">
                <div className="px-1 py-4">
                  {" "}
                  <h1>Printing Material Specification</h1>
                </div>
              </div>
              {/* <div className="flex flex-col mx-5 my-2">
                <label
                  style={{
                    fontWeight: "400",
                    color: "#36383A",
                  }}
                >
                  Product Category
                </label>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.5rem", marginBottom: "7px" }}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    name={`productCategoryForPrinting-${index}`}
                    value={scopeOfWork?.productCategoryForPrinting || ""}
                    onChange={(e) => {
                      handleInputChange(e, index);
                    }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--listdown-color)]">
                            Type of Printing
                          </p>
                        );
                      }
                      return <span style={{ color: "#000" }}>{selected}</span>;
                    }}
                  >
                    {productCategoryForPrinting.map((productCategory, i) => (
                      <MenuItem value={productCategory} key={i}>
                        <Radio
                          checked={
                            scopeOfWork?.productCategoryForPrinting ===
                            productCategory
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              handleInputChange(
                                {
                                  target: {
                                    name: `productCategoryForPrinting-${index}`,
                                    value: productCategory,
                                  },
                                },
                                index
                              );
                            }
                          }}
                          style={{ paddingRight: "8px" }}
                        />
                        {productCategory}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div> */}

              <div className="border p-2 mx-5 my-4 rounded-lg">
                <h1 className="font-[600]">Print Specifications</h1>
                <div className="border w-full  my-2 rounded-lg" />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 p-6 gap-8 mt-2 ">
                  <CustomInput
                    name={`printMaterialsubstrate-${index}`}
                    placeholder="Enter Substrate"
                    title="Print Material Substrate"
                    type="text"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm(scopeOfWork);
                    }}
                    value={
                      scopeOfWork?.materialDetailsForPrinting
                        ?.printMaterialsubstrate
                    }
                    error={errors.printMaterial?.substrate}
                  />
                  <CustomInput
                    name={`printMaterialbrand-${index}`}
                    placeholder="Enter Brand"
                    title="Print Material Brand"
                    type="text"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm(scopeOfWork);
                    }}
                    value={
                      scopeOfWork?.materialDetailsForPrinting
                        ?.printMaterialbrand
                    }
                    error={errors.printMaterial?.brand}
                  />
                  <CustomInput
                    name={`printMaterialgrade-${index}`}
                    placeholder="Enter Grade"
                    title="Print Material Grade"
                    type="text"
                    size="small"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm(scopeOfWork);
                    }}
                    value={
                      scopeOfWork?.materialDetailsForPrinting
                        ?.printMaterialgrade
                    }
                    error={errors.printMaterial?.grade}
                  />

                  {errors.printMaterial && (
                    <span
                      className=" ml-4"
                      style={{ color: "var(--error-color) !important" }}
                    >
                      Please Enter Print Material
                    </span>
                  )}

                  <div className=" flex flex-col">
                    <CustomInput
                      name={`artWork-${index}`}
                      placeholder=" Enter Art Work"
                      title="Art Work ( Max Size )"
                      size="small"
                      onKeyDown={(e) => {
                        if (
                          e.key === "e" ||
                          e.key === "E" ||
                          e.key === "+" ||
                          e.key === "-" ||
                          e.key === "."
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (!value.startsWith(" ")) {
                          handleInputChange(
                            { target: { name: e.target.name, value } },
                            index
                          );
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) validateForm(scopeOfWork);
                      }}
                      errorMessage={
                        errors.artWork ? "Please Enter Art work" : null
                      }
                      error={errors.artWork}
                      value={scopeOfWork?.materialDetailsForPrinting?.artWork}
                    />
                  </div>
                  <div className=" flex flex-col">
                    <CustomInput
                      name={`printGSM-${index}`}
                      placeholder="Enter GSM"
                      title="Substrate Thickness ( GSM/mm )"
                      size="small"
                      type="text"
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e, index);
                        }
                      }}
                      value={scopeOfWork?.materialDetailsForPrinting?.printGSM}
                    />
                  </div>
                  <div className=" flex flex-col">
                    <CustomInput
                      name={`outerSize-${index}`}
                      placeholder=" Enter Outer Size"
                      title="Outer Size"
                      size="small"
                      required
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e, index);
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) validateForm(scopeOfWork);
                      }}
                      errorMessage={
                        errors.outerSize ? "Please Enter Outer Size" : null
                      }
                      error={errors.outerSize}
                      value={scopeOfWork?.materialDetailsForPrinting?.outerSize}
                    />
                  </div>
                  {/* <div className=" flex flex-col">
                    <CustomInput
                      name={`brand-${index}`}
                      placeholder="Enter Brand"
                      title="Brand"
                      size="small"
                      required
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e, index);
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) validateForm(scopeOfWork);
                      }}
                      errorMessage={
                        errors.brand ? "Please Enter Outer brand" : null
                      }
                      error={errors.brand}
                      value={
                        scopeOfWork?.materialDetailsForPrinting?.brand || ""
                      }
                    />
                  </div> */}

                  <div className="flex flex-col">
                    <FormControl fullWidth size="small">
                      <label style={{ fontWeight: "400", color: "#36383A" }}>
                        Application Place
                      </label>
                      <Select
                        name={`applicationPlace-${index}`}
                        value={
                          scopeOfWork?.materialDetailsForPrinting
                            ?.applicationPlace || ""
                        }
                        onChange={(e) => {
                          handleInputChange(e, index);
                        }}
                        onBlur={(e) => {
                          emptyInputCheck(e.target.name, e.target.value);
                          if (saveButtonClicked) validateForm(scopeOfWork);
                        }}
                        displayEmpty
                        inputProps={{
                          "aria-label": "Select Application Place",
                        }}
                        sx={{ marginTop: "0.5rem" }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <span className="text-[var(--listdown-color)]">
                                Select Application Place
                              </span>
                            );
                          }
                          return selected;
                        }}
                        error={errors.applicationPlace}
                      >
                        <MenuItem value="Indoor">
                          <Radio
                            checked={
                              scopeOfWork?.materialDetailsForPrinting
                                ?.applicationPlace === "Indoor"
                            }
                            onChange={() => {
                              handleInputChange(
                                {
                                  target: {
                                    name: `applicationPlace-${index}`,
                                    value: "Indoor",
                                  },
                                },
                                index
                              );
                            }}
                            style={{ paddingRight: "8px" }}
                          />
                          Indoor
                        </MenuItem>
                        <MenuItem value="Outdoor">
                          <Radio
                            checked={
                              scopeOfWork?.materialDetailsForPrinting
                                ?.applicationPlace === "Outdoor"
                            }
                            onChange={() => {
                              handleInputChange(
                                {
                                  target: {
                                    name: `applicationPlace-${index}`,
                                    value: "Outdoor",
                                  },
                                },
                                index
                              );
                            }}
                            style={{ paddingRight: "8px" }}
                          />
                          Outdoor
                        </MenuItem>
                      </Select>
                      {errors.applicationPlace && (
                        <p className="text-[var(--error-color)] text-[12px] mt-1">
                          Please select if it is Indoor or Outdoor
                        </p>
                      )}
                    </FormControl>
                  </div>
                  <div className="flex flex-col">
                    <label style={{ fontWeight: "400", color: "#36383A" }}>
                      Installation Types
                    </label>
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ marginTop: "0.5rem", marginBottom: "7px" }}
                    >
                      <Select
                        inputProps={{ "aria-label": "Without label" }}
                        displayEmpty
                        name={`installation-${index}`}
                        value={scopeOfWork?.installation}
                        onChange={(e) => {
                          handleInputChange(e, index);
                        }}
                        renderValue={(selected) => {
                          if (!selected || selected.length === 0) {
                            return (
                              <p className="text-[1rem] text-[var(--listdown-color)]">
                                Select Installation
                              </p>
                            );
                          }
                          return (
                            <span style={{ color: "#000" }}>{selected}</span>
                          );
                        }}
                      >
                        {installationCategories.map((category, i) => (
                          <MenuItem key={i} value={category}>
                            <Radio
                              checked={scopeOfWork?.installation === category}
                              onChange={(e) =>
                                handleInputChange(
                                  {
                                    target: {
                                      name: `installation-${index}`,
                                      value: category,
                                    },
                                  },
                                  index
                                )
                              }
                              style={{ paddingRight: "8px" }}
                            />
                            {category}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="border p-2 mx-5 my-4 rounded-lg">
                <h1 className="font-[600]">{`Printing Parameters`}</h1>
                <div className="border w-full  my-2 rounded-lg" />

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-4 p-6  rounded-md">
                  <div className=" flex flex-col">
                    <CustomInput
                      name={`printDPI-${index}`}
                      placeholder=" Enter Print DPI"
                      title="Print DPI"
                      size="small"
                      required
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e, index);
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) validateForm(scopeOfWork);
                      }}
                      errorMessage={
                        errors.printDPI ? "Please Enter Print DPI" : null
                      }
                      error={errors.printDPI}
                      value={
                        scopeOfWork?.printingParametersForPrinting?.printDPI
                      }
                    />
                  </div>
                  {/* <div className=" flex flex-col">
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ marginBottom: "7px" }}
                    >
                      <label
                        style={{
                          fontWeight: "400",
                          color: "#36383A",
                        }}
                      >
                        Color Code
                      </label>
                      <Select
                        name={`colorCode-${index}`}
                        value={
                          scopeOfWork?.printingParametersForPrinting
                            ?.colorCode || ""
                        }
                        onChange={(e) => {
                          handleInputChange(e, index);
                        }}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <span className="text-[var(--listdown-color)]">
                                Select Color Code
                              </span>
                            );
                          }
                          return selected;
                        }}
                        inputProps={{
                          "aria-label": "Select Color Code",
                        }}
                        sx={{ marginTop: "0.5rem" }}
                        error={!!errors.colorCode}
                      >
                        <MenuItem value="CMYK">
                          <Radio
                            checked={
                              scopeOfWork?.printingParametersForPrinting
                                ?.colorCode === "CMYK"
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                handleInputChange(
                                  {
                                    target: {
                                      name: `colorCode-${index}`,
                                      value: "CMYK",
                                    },
                                  },
                                  index
                                );
                              }
                            }}
                            style={{ paddingRight: "8px" }}
                          />
                          CMYK
                        </MenuItem>

                        //{ Pantone Option }
                        <MenuItem value="Pantone">
                          <Radio
                            checked={
                              scopeOfWork?.printingParametersForPrinting
                                ?.colorCode === "Pantone"
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                handleInputChange(
                                  {
                                    target: {
                                      name: `colorCode-${index}`,
                                      value: "Pantone",
                                    },
                                  },
                                  index
                                );
                              }
                            }}
                            style={{ paddingRight: "8px" }}
                          />
                          Pantone
                        </MenuItem>
                         <MenuItem value="CMYK">CMYK</MenuItem>
                    <MenuItem value="Pantone">Pantone</MenuItem> 
                      </Select>
                      {errors.colorCode && (
                        <p className="text-[var(--error-color)] text-[12px] ml-3">
                          {errors.colorCode}
                        </p>
                      )}
                    </FormControl>
                  </div>

                  {scopeOfWork?.printingParametersForPrinting?.colorCode ===
                    "CMYK" && (
                    <div className=" flex flex-col">
                      <CustomInput
                        name={`colorCodeDetails-${index}`}
                        placeholder="Enter ( CCC/YYY/MMM/KKK )"
                        title="Type of Color Code"
                        size="small"
                        required
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/\D/g, "");
                          const parts = [];
                          for (let i = 0; i < value.length; i += 3) {
                            parts.push(value.slice(i, i + 3));
                          }

                          const formattedValue = parts.join("/");

                          if (parts.length <= 4) {
                            handleInputChange(
                              {
                                target: {
                                  name: `colorCodeDetails-${index}`,
                                  value: formattedValue,
                                },
                              },
                              index
                            );
                          }
                        }}
                        onBlur={(e) => {
                          emptyInputCheck(e.target.name, e.target.value);
                          if (saveButtonClicked) validateForm(scopeOfWork);
                        }}
                        error={errors?.colorCodeDetails}
                        value={
                          scopeOfWork?.printingParametersForPrinting
                            ?.colorCodeDetails || ""
                        }
                      />
                    </div>
                  )}
                  {scopeOfWork?.printingParametersForPrinting?.colorCode ===
                    "Pantone" && (
                    <div className=" flex flex-col">
                      <div className="grid grid-cols-1 ">
                        <CustomInput
                          name={`colorCodeDetails-${index}`}
                          placeholder="Enter Pantone Code"
                          title="Type of Color Code"
                          size="small"
                          required
                          onChange={(e) => {
                            if (!e.target.value.startsWith(" ")) {
                              handleInputChange(e, index);
                            }
                          }}
                          onBlur={(e) => {
                            emptyInputCheck(e.target.name, e.target.value);
                            if (saveButtonClicked) validateForm(scopeOfWork);
                          }}
                          error={errors?.colorCodeDetails}
                          value={
                            scopeOfWork?.printingParametersForPrinting
                              ?.colorCodeDetails || ""
                          }
                        />
                      </div>
                    </div>
                  )} */}
                  <div className=" flex flex-col">
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ marginBottom: "7px" }}
                    >
                      <label
                        style={{
                          fontWeight: "400",
                          color: "#36383A",
                        }}
                      >
                        Layer
                      </label>
                      <Select
                        name={`layer-${index}`}
                        value={
                          scopeOfWork?.printingParametersForPrinting?.layer ||
                          ""
                        }
                        onChange={(e) => {
                          handleInputChange(e, index);
                        }}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <span className="text-[var(--listdown-color)]">
                                Select Layer
                              </span>
                            );
                          }
                          return selected;
                        }}
                        inputProps={{
                          "aria-label": "Select Layer",
                        }}
                        sx={{ marginTop: "0.5rem" }}
                        error={!!errors.layer}
                      >
                        {[1, 2, 3, 4].map((number) => (
                          <MenuItem key={number} value={number}>
                            <Radio
                              checked={
                                scopeOfWork?.printingParametersForPrinting
                                  ?.layer === number
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  handleInputChange(
                                    {
                                      target: {
                                        name: `layer-${index}`,
                                        value: number,
                                      },
                                    },
                                    index
                                  );
                                }
                              }}
                              style={{ paddingRight: "8px" }}
                            />
                            {number}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.layer && (
                        <p className="text-[var(--error-color)] text-[12px] ml-3">
                          {errors.layer}
                        </p>
                      )}
                    </FormControl>
                  </div>
                  <div className=" flex flex-col">
                    <CustomInput
                      name={`passes-${index}`}
                      placeholder=" Enter Passes"
                      title="Passes"
                      size="small"
                      required
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e, index);
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) validateForm(scopeOfWork);
                      }}
                      errorMessage={
                        errors.passes ? "Please Enter Color Code" : null
                      }
                      error={errors.passes}
                      value={scopeOfWork?.printingParametersForPrinting?.passes}
                    />
                  </div>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ marginBottom: "14px" }}
                  >
                    <label style={{ fontWeight: "400", color: "#36383A" }}>
                      Print On Sides (Single/Back2Back)
                    </label>
                    <Select
                      name={`printOnSides-${index}`}
                      value={
                        scopeOfWork?.printingParametersForPrinting
                          ?.printOnSides || ""
                      }
                      onChange={(e) => {
                        handleInputChange(e, index);
                      }}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span className="text-[var(--listdown-color)]">
                              Select Print Side
                            </span>
                          );
                        }
                        return selected;
                      }}
                      inputProps={{ "aria-label": "Select Print Side" }}
                      sx={{ marginTop: "0.5rem" }}
                    >
                      <MenuItem value="Single">
                        <Radio
                          checked={
                            scopeOfWork?.printingParametersForPrinting
                              ?.printOnSides === "Single"
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              handleInputChange(
                                {
                                  target: {
                                    name: `printOnSides-${index}`,
                                    value: "Single",
                                  },
                                },
                                index
                              );
                            }
                          }}
                          style={{ paddingRight: "8px" }}
                        />
                        Single
                      </MenuItem>

                      <MenuItem value="Back2Back">
                        <Radio
                          checked={
                            scopeOfWork?.printingParametersForPrinting
                              ?.printOnSides === "Back2Back"
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              handleInputChange(
                                {
                                  target: {
                                    name: `printOnSides-${index}`,
                                    value: "Back2Back",
                                  },
                                },
                                index
                              );
                            }
                          }}
                          style={{ paddingRight: "8px" }}
                        />
                        Back2Back
                      </MenuItem>
                    </Select>
                    {errors.printOnSides && (
                      <p
                        style={{
                          color: "var(--error-color)",
                          fontSize: "0.75rem",
                          marginTop: "4px",
                        }}
                      >
                        Please select Single or Back2Back
                      </p>
                    )}
                  </FormControl>
                </div>
              </div>
            </div>
          )}

          {scopeOfWork?.servicesNeeded?.includes("Printing") && (
            <div className="border  rounded-lg mb-8 mt-8 shadow-lg">
              <div className="flex justify-between items-center w-full bg-[#e0edf4] p-2 rounded-t-lg">
                <div className="flex justify-center items-center py-2">
                  <h1>Printing Guidelines</h1>
                </div>
              </div>
              <div className="flex justify-center items-center">
                <TextField
                  className="text-xs font-medium leading-6 text-left w-full"
                  placeholder="Enter Your +"
                  title="Printing Guidelines"
                  multiline
                  type="text"
                  rows={5}
                  size="small"
                  name={`printingGuidelines-${index}`}
                  value={
                    scopeOfWork?.printingGuidelines?.startsWith("•")
                      ? scopeOfWork.printingGuidelines
                      : "• " + (scopeOfWork?.printingGuidelines ?? "")
                  }
                  onChange={(e) => handleInputChange(e, index)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const currentValue =
                        scopeOfWork?.printingGuidelines || "";

                      const newValue = currentValue + "\n• ";
                      const syntheticEvent = {
                        target: {
                          name: `printingGuidelines-${index}`,
                          value: newValue,
                        },
                      };

                      handleInputChange(syntheticEvent, index);
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "var(--primary-color)",
                      },
                    },
                  }}
                />
              </div>
            </div>
          )}

          {/* {scopeOfWork?.locationsList?.length === 0 ? (
            <div className="border  rounded-lg mb-8 shadow-lg">
              <div className="flex justify-between items-center w-full bg-[#e0edf4] p-2 rounded-t-lg">
                <div className="flex justify-center items-center">
                  <h1
                    style={{
                      color: errors[`locationsList-${index}`]
                        ? "var(--error-color)"
                        : "inherit",
                    }}
                  >
                    Sites
                  </h1>
                  <span
                    style={{
                      color: "var(--error-color)",
                    }}
                  >
                    *
                  </span>
                </div>
                <div>
                  <div className="flex justify-center items-center  mb-2">
                    {excelLoading ? (
                      <CircularProgress size={30} />
                    ) : (
                      <div>
                        <input
                          type="file"
                          ref={fileInputForExcelRef}
                          name={`locationsList-${index}`}
                          onChange={async (e) => {
                            handleInputChange(e, index);
                          }}
                          style={{
                            display: "none",
                          }}
                          accept=".xlsx"
                        />
                        <button
                          onClick={handleIconClickForExcel}
                          className="px-2 py-2 w-36 gap-2 items-center justify-center mr-2 flex cursor-pointer text-[var(--secondary-color)] bg-[var(--primary-color)] border-[var(--primary-color)] border rounded-lg"
                        >
                          <ImportSiteIcon />
                          Import Sites
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center">
                <h3 className="w-full text-center mt-2 p-5 ">
                  There is no location added yet
                </h3>
              </div>
            </div>
          ) : (
            <>
              <Grid
                className="bg-[var(--secondary-color)] shadow-md  p-4 border rounded-lg my-5"
                spacing={3}
              >
                <div className="flex justify-between items-center">
                  <div className="flex flex-col  mb-5  lg:flex-row justify-between items-center gap-7">
                    <h1 className="font-[600]">{`Locations : ${scopeOfWork?.locationsList?.length}`}</h1>
                  </div>
                  <button
                    onClick={handleDeleteExcel}
                    className="px-2 py-2 w-36 gap-2 items-center mb-5 justify-center mr-2 flex cursor-pointer text-[var(--secondary-color)] bg-[var(--error-color)] border-[var(--secondary-color)] border rounded-lg"
                  >
                    <ImportSiteIcon />
                    Delete Sites
                  </button>
                </div>

                <TableContainer
                  className={`mt-5 rounded-lg ${style["custom-scrollbar"]}`}
                  sx={{
                    overflowY: "auto",
                    maxWidth: "full",
                    margin: "auto",
                    maxHeight: 300,
                  }}
                >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {columns?.map((column) => (
                          <TableCell
                            key={column.field}
                            sx={{
                              whiteSpace: "nowrap",
                              fontWeight: "550",
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#e0e0e0",
                              width: column.width,
                              zIndex: 2,
                            }}
                          >
                            <span
                              style={{ lineHeight: "1", width: column.width }}
                            >
                              {column.headerName
                                .toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")}
                            </span>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {scopeOfWork?.locationsList?.map((location, i) => {
                        return (
                          <TableRow key={i}>
                            <TableCell>{i + 1 + "."}</TableCell>
                            <TableCell>
                              {location?.storeName
                                ? location.storeName.charAt(0).toUpperCase() +
                                  location.storeName.slice(1)
                                : "N/A"}
                            </TableCell>
                            <TableCell align="left">
                              <div className="flex justify-center items-center">
                                <div className="border text-[var(--primary-color)] px-2 py-1 rounded">
                                  {location?.storeOwnerName
                                    ?.split(" ")
                                    .map((ele) => ele.charAt(0).toUpperCase())
                                    .join("")}
                                </div>

                                <div className="ml-2">
                                  <span className="block font-medium">
                                    {location?.storeOwnerName
                                      ? location.storeOwnerName
                                          .charAt(0)
                                          .toUpperCase() +
                                        location.storeOwnerName.slice(1)
                                      : "N/A"}
                                  </span>
                                  <span className="text-gray-400 text-xs">
                                    {location?.storeOwnerPhoneNumber ?? "NA"}
                                  </span>
                                </div>
                              </div>
                            </TableCell>

                            <TableCell align="left">
                              {typeof location.address === "string"
                                ? location.address
                                : location.address?.richText
                                    ?.map((item) => item.text)
                                    .join(" ")}
                            </TableCell>
                            <TableCell align="left">
                              {location?.zipCode}
                            </TableCell>

                            <TableCell align="left">{location?.city}</TableCell>
                            <TableCell align="left">
                              {location?.state}
                            </TableCell>
                            <TableCell align="center">
                              {scopeOfWork?.productDimensions[i]
                                ?.productWidth || "N/A"}
                            </TableCell>
                            <TableCell align="center">
                              {scopeOfWork?.productDimensions[i]
                                ?.productHeight || "N/A"}
                            </TableCell>

                            <TableCell align="center">
                              {scopeOfWork?.productDimensions[i]
                                ?.productThickness || "N/A"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </>
          )}
          {errors[`locationsList-${index}`] ? (
            <span className=" ml-4" style={{ color: "var(--error-color)" }}>
              {errors[`locationsList-${index}`]}
            </span>
          ) : (
            ""
          )} */}
          <ExcelLocationUploader
            deleteCheck={deleteCheck}
            scopeOfWork={scopeOfWork}
            index={index}
            excelLoading={excelLoading}
            handleIconClickForExcel={handleIconClickForExcel}
            handleInputChange={handleInputChange}
            fileInputForExcelRef={fileInputForExcelRef}
            handleDeleteExcel={handleDeleteExcel}
            columns={columns}
            errors={errors}
          />
        </Box>
      </Grid>
    </div>
  );
};

export default ProductComponent;

const servicesList = [
  "Recce",
  "Fabrication",
  "Printing",
  "Installation",
  "Audit",
];

const productCategoryForFabrication = [
  "Glow Sign Boards",
  "ACP Sign Board",
  "Lollipop Signage",
  "3D letters",
  "Flex Frame Signage",
  "Aluminium Backlit Signage",
];
const installationCategories = [
  "Installation Table Top",
  "Installation Floor",
  "Installation Projected",
  "Installation Ceiling",
  "Installation Wall",
];

const productCategoryForPrinting = [
  "Solvent Print",
  "Ecosolvent Printing",
  "UV Print",
  "Latex Printing",
  "Plotter Cutting Printing",
  "Vinyl Branding",
  "POS",
];
const combinedCategories = [
  ...productCategoryForFabrication,
  ...productCategoryForPrinting,
];

const categoryLabels = {
  subCategory: "Sub Category",
  ampereOfMachine: "Ampere Of Machine",
  controllerSetting: "Controller Setting",
  ageOfMachine: "Age Of Machine",
  powerOfMachine: "Power Of Machine",
  lengthFoot: "Length (Ft.)",
  breadthFoot: "Breadth (Ft.)",
};
const width = {
  "Ecosolvent Printing": [
    { value: "5", label: "5'" },
    { value: "10", label: "10'" },
  ],
  "UV Printing": [
    { value: "2", label: "2'" },
    { value: "4", label: "4'" },
    { value: "6", label: "6'" },
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
    { value: "12", label: "12'" },
    { value: "14", label: "14'" },
  ],
  "Digital Printing": [
    { value: "4", label: "4'" },
    { value: "5", label: "5'" },
    { value: "6", label: "6'" },
  ],
  "Solvent Printing": [
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
    { value: "12", label: "12'" },
    { value: "14", label: "14'" },
  ],
  "Plotter Cutting Printing": [
    { value: "2", label: "2'" },
    { value: "3", label: "3'" },
    { value: "4", label: "4'" },
    { value: "5", label: "5'" },
  ],
  "Latex Printing": [
    { value: "5", label: "5'" },
    { value: "7", label: "7'" },
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
  ],
};
const brandNames = [
  {
    value: "Ecosolvent Printing",
    brandNames: [
      "Roland",
      "Mimaki",
      "Xuly",
      "Konica",
      "ColorJet",
      "V K",
      "Infinity",
      "Chinese",
      "VuTek",
      "Epson",
      "AuraJet",
      "Any Brand",
    ],
  },
  {
    value: "UV Printing",
    brandNames: [
      "Mimaki",
      "FujiFilm",
      "Docan",
      "Keoundo",
      "Chinese",
      "V K",
      "Infinity",
      "Ricoh",
      "HandTop",
      "Any Brand",
    ],
  },
  {
    value: "Digital Printing",
    brandNames: ["HP", "Canon", "Roland", "Any Brands"],
  },

  {
    value: "Solvent Printing",
    brandNames: [
      "AllWin",
      "UltraJet",
      "ColorJet",
      "Grayscale",
      "Konica 512i",
      "V K",
      "Infinity",
      "Mimaki",
      "VuTek",
      "MehtaFlex",
      "I-Jet",
      "Ink-Jet",
      "Any Brand",
    ],
  },

  {
    value: "Latex Printing",
    brandNames: ["HP", "Any Brand"],
  },
  {
    value: "Plotter Cutting Printing",
    brandNames: [
      "Graphtec",
      "Roland",
      "Saga",
      "Dragon Cut",
      "Chinese",
      "Mimaki",
      "Scy Cut",
      "Any Brand",
    ],
  },
];
